import { useEffect, useState } from 'react';

export const MoneyInput = ({
  value,
  setValue,
  currencySymbol = '$',
  precision = 2,
}: {
  value: number;
  setValue: (v: number) => void;
  currencySymbol?: string;
  precision?: number;
}) => {
  const [valueStr, setValueStr] = useState<string>(value ? value.toString() : '');
  console.log(valueStr);
  useEffect(() => {
    const numericVal = parseFloat(valueStr);
    if (!isNaN(numericVal)) {
      setValue(numericVal);
    }
  }, [valueStr]);

  useEffect(() => {
    onChange(value.toString());
  }, [value]);
  function onChange(str: string) {
    const parts = str.replace(/[^\d.-]/g, '').split('.');
    const dollars = parts[0];
    if (parts.length > 1) {
      const cents = parts[1].substring(0, precision);
      setValueStr(`${dollars}.${cents}`);
    } else {
      setValueStr(`${dollars}`);
    }
  }

  return (
    <span className="h-[44px] p-[10px] border border-solid border-[var(--grey-300)] rounded-lg flex-[0_1_62%] flex items-center">
      <span className="ml-1 quipli-v2 text-md flex-[0_1_5%] ">{currencySymbol}</span>
      <input
        type="text"
        className="appearance-textfield !outline-none !border-0 !border-none quipli-v2 text-md flex-[0_1_95%]"
        value={valueStr}
        onChange={(e) => onChange(e.target.value)}
      />
    </span>
  );
};
